import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { StyledEngineProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import { DemoContainer , DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import customParseFormat from 'dayjs/plugin/customParseFormat';


// import { useNavigate } from "react-router-dom";
import Select from "react-select";
//const optionDataMasterBucket=['Select Status Type','Installation Pending','hold','Assigned','UnAssigned','Consumption Pending','consumption Approved','Installation Completed'];
const optionDataMasterBucket = [
  { value: "Select Status Type", label: "Select Status Type" },
  { value: "Installation Pending", label: "Installation Pending" },
  { value: "hold", label: "hold" },
  { value: "Assigned", label: "Assigned" },
  { value: "Unassigned", label: "Unassigned" },
  { value: "Consumption Pending", label: "Consumption Pending" },
  { value: "Consumption Approved", label: "Consumption Approved" },
  { value: "Installation Completed", label: "Installation Completed" },
  { value: "Installation Not Done", label: "Installation Not Done" },
  
];

//const optionDataMyBucket=['Select Status Type','Installation Pending','hold','Consumption Pending','consumption Approved','Installation Completed'];
const optionDataMyBucket = [
  { value: "Select Status Type", label: "Select Status Type" },
  { value: "Installation Pending", label: "Installation Pending" },
  { value: "hold", label: "hold" },
  { value: "Consumption Pending", label: "Consumption Pending" },
  { value: "Consumption Approved", label: "Consumption Approved" },
  { value: "Installation Completed", label: "Installation Completed" },
];




const Installation = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  const [selectDataMasterBucket, setSelectDataMasterBucket] = useState(
    optionDataMasterBucket[0]
  );
  const [selectDataMyBucket, setSelectDataMyBucket] = useState(
    optionDataMyBucket[0]
  );
  const [EngineerBucketData, setEngineerBucketData] = useState([]);
  const [InstallationDataAll, SetInstallationDataAll] = useState([]);
  const [venderCode, setVenderCode] = useState("");
  const [EngineerID, setEngineerID] = useState("");
  const [totalCountMasterBucket, setTotalCountMasterBucket] = useState("");
  const [totalCountMyBucket, setTotalCountMyBucket] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [searchFlag, setSearchFlag] = useState(false);
  const [searchInputMyBucket, setSearchInputMyBucket] = useState("");
  const [searchCount, setSearchCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedDates, setSelectedDates] = useState({});


  const handleSelectMasterBucket = (e) => {
    // console.log(e.label);
    setSelectDataMasterBucket(e);
  };
  const handleSelectDataMyBucket = (e) => {
    // console.log("e",e);
    setSelectDataMyBucket(e);
  };

  // const addToMyBucket=(install) =>{
  //   console.log(install);
  // }


  const redirectToProvisioning = (e) => {
    if (handleDateTimeChange == ''){
      return
    }else{
      // console.log("e", e);
      sessionStorage.setItem("AppointmentDate", e.appointmentDate);
      sessionStorage.setItem("WCRguidId", e.wcrId);
      sessionStorage.setItem("OrderID", e.order_id);
      sessionStorage.setItem("CanId", e.customerID);
      navigate("/installationprovisioning");
    }
  
  };

  const addToMyBucket = async (install) => {
    try {
      // setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "addOrderToBucket",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        AreaName: install.areaName,
        CRM_status: install.status,
        ContactNo: install.contactNo,
        ContactPerson: install.contactPerson,
        ActivationOTP: install.activationOTP,
        CustomerAddress: install.address,
        CustomerCityId: install.cityId,
        CustomerName: install.customerName,
        EngineerID: sessionStorage.getItem("userId"),
        EngineerName: install.engineerName,
        HoldCategory: install.holdCategory,
        HoldReason: "",
        IRSlaClock: install.irslaclock,
        OrderCreatedOn: install.createdOn,
        Order_id: install.ID,
        Product: install.product,
        Segment: install.businessSegment,
        SlaStatus: install.slaStatus,
        WCRstatus: "",
        IRstatus: "",
        ItemConsumption: "",
        VendorCode: install.vendorCode,
        VendorName: install.vendorName,
        WCRId: install.wcrId,
        WCRSlaClock: install.wcrslaclock,
        accountTurnOver: install.accountTurnOver,
        customerCategory: install.customerCategory,
        externalCustomerSegment: install.externalCustomerSegment,
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (result && result.Response && result.Response.Data) {
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    setVenderCode(sessionStorage.getItem("vendorCode"));
    //console.log('SessionData',sessionStorage);
    setEngineerID(sessionStorage.getItem("userId"));
    // async function valiDateUserAPI() {
    //   const url =  process.env.REACT_APP_API_URL;
    //   const data = {
    //     "Action": "validateUser",
    //     "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //     "UserName": sessionStorage.getItem('userName')+ "@spectra.co",
    //     "UserPass": sessionStorage.getItem('password'),
    //     "UserType": "I"
    //   };
    //   const response = await fetch(url, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify(data)
    //   });
    //   const result = await response.json();
    //   // console.log("result",result);
    //   if(result.Status != "Failure"){
    //   setVenderCode(result ? result.Response[0].vendorCode : "");
    //   sessionStorage.setItem("emailId",result ? result.Response[0].emailId : "")
    //   sessionStorage.setItem("field_force",result ?result.Response[0].field_force : "")
    //   sessionStorage.setItem("installation",result ?result.Response[0].installation : "")
    //   sessionStorage.setItem("name",result ?result.Response[0].name : "")
    //   sessionStorage.setItem("userId",result ?result.Response[0].userId : "")
    //   sessionStorage.setItem("vendorCode",result ?result.Response[0].vendorCode : "")
    //   }

    // }
    // valiDateUserAPI();
  }, []);
  const navigate = useNavigate();
  const redirectDashboardPage = () => {
    navigate("/dashboard");
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        
        const requestData = {
          Action: "getInstallationOrders",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          // "VendorCode": "INsamji.samkutty"
          VendorCode: !sessionStorage.getItem("vendorCode") ? sessionStorage.getItem("vendorCode"): "",
          // VendorCode: sessionStorage.getItem("vendorCode"),
        };
        // console.log("Request Data:", requestData);
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log("API Response:", result);

        //   if (
        //     result &&
        //     result.Response &&
        //     result.Response.Status !== "Failure"
        //   ) {
        //     //console.log('Actual Data:', result.Response.Data);
        //     console.log("Master Bucket", result.Response);
        //     SetInstallationDataAll(result.Response);
        //     setTotalCountMasterBucket(result.Response.length);
        //   } else {
        //     const errorMessage =
        //       result && result.Response && result.Response.Message;
        //     toast.warning(`${errorMessage}`, {
        //       position: toast.POSITION.BOTTOM_CENTER,
        //       autoClose: 1500,
        //     });
        //   }
        // } 
        if (result && result.Response && result.Response.Status !== "Failure") {
          // console.log("Master Bucket", result.Response);

          if (Array.isArray(result.Response)) {
            SetInstallationDataAll(result.Response);
            setTotalCountMasterBucket(result.Response.length);
          } else {
            // console.error("Fetched data is not an array");
            toast.warning(result.Response.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } else {
          const errorMessage = result && result.Response && result.Response.Message;
          toast.warning(`${errorMessage}`, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      }
        else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    if (venderCode) {
      fetchData();
    }
  }, [venderCode]);

  useEffect(() => {
    const fetchDataMyBucket = async () => {
      try {
        //setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "engineerBucket",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          EngineerID: EngineerID,
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log("API Response:", result);


      
        if (result && result.Response && result.Response.Status !== "Failure") {
          // console.log("Engineer Bucket:", result.Response);
          if (Array.isArray(result.Response)) {

            setEngineerBucketData(result.Response);
            setTotalCountMyBucket(result.Response.length);
          } else {

          
            const errorMessage =
              result && result.Response && result.Response.Message;
            toast.warning(`${errorMessage}`, {

              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } else {
          const errorMessage = result && result.Response && result.Response.Message;
          toast.warning(`${errorMessage}`, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      }
         else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        //  setLoading(false);
      }
    };
    if (EngineerID) {
      fetchDataMyBucket();
    }
  }, [EngineerID]);

  useEffect(() => {
    // Initialize the selected dates state with initial appointment dates from EngineerBucketData
    const initialDates = EngineerBucketData.reduce((acc, Bucket) => {
      if (Bucket.appointmentDate) {
        const parsedDate = dayjs(Bucket.appointmentDate, 'YYYY-MM-DD HH:mm A');
        acc[Bucket.customerID] = parsedDate.isValid() ? parsedDate : null;
      } else {
        acc[Bucket.customerID] = null;
      }
      return acc;
    }, {});
    setSelectedDates(initialDates);
  }, [EngineerBucketData]);
  
  const handleDateTimeChange = (newValue, customerID) => {
    setSelectedDates(prevDates => ({
      ...prevDates,
      [customerID]: newValue,
    }));
  };

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchInputChangeMyBucket = (event) => {
    // console.log('event',event)
    setSearchInputMyBucket(event.target.value);
  };
  const handleSearchClick = () => {
    // console.log("searchInput", searchInput);
    // Reset total count
    // setTotalCountMasterBucket(0)
    setTotalCount(0);
    setSearchFlag(true);
    // console.log("InstallationDataAll", InstallationDataAll);
    // Iterate over the response array to search for the specified canId
    InstallationDataAll.forEach((item) => {
      if (item.canId == searchInput) {
        // console.log("item.canId", item.canId);
        setTotalCount((prevCount) => prevCount + 1);
      }
    });
  };

  const handleSearchClickMyBucket = () => {
    // console.log("setSearchInputMyBucket", searchInputMyBucket);
    // Reset total count
    // setTotalCountMasterBucket(0)
    setSearchCount(0);
    setSearchFlag(true);
    // console.log("EngineerBucketData",EngineerBucketData);
    // Iterate over the response array to search for the specified canId
    EngineerBucketData.forEach((item) => {
      // console.log("item.order_id",item.order_id);
      if (item.order_id == searchInputMyBucket ||item.customerID  == searchInputMyBucket ) {
        // console.log("item.canId1", item.order_id);
        setSearchCount((prevCount) => prevCount + 1);
      }
    });
  };
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectDashboardPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Installation Order</span>
        </div>
        {/* Navigation tabs: Master Bucket, My Bucket */}
        <div className=" container-fluid">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                className="nav-link "
                data-bs-toggle="tab"
                href="#masterBucket"
              >
                Master Bucket
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link active" data-bs-toggle="tab" href="#myBucket">
                My Bucket
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content tab-main-content">
        {/* ****************** Master Bucket TAB ************* */}
        <div className="tab-pane fade show" id="masterBucket">
          <div className="container-fluid mb-1  p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input
                  type="text"
                  placeholder="Search"
                  className="search-box p-1 border-0"
                  style={{ width: "250px" }}
                  value={searchInput}
                  onChange={handleSearchInputChange}
                />
                <i
                  className="fas fa-search text-secondary"
                  style={{ marginLeft: "-25px" }}
                  onClick={handleSearchClick}
                ></i>
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                className=" bg-light text-center m-1"
                style={{ width: "50px", height: "28px" }}
              >
                {searchInput > 0 ? totalCount : totalCountMasterBucket}
              </span>
            </div>
          </div>

          <div className="division ">
            <div className="row">
              <div className="col-5">
                <div className="line l"></div>
              </div>
              <div className="col-2">
                <span>OR</span>
              </div>
              <div className="col-5">
                <div className="line r"></div>
              </div>
            </div>
          </div>

          <div className="container mb-4 d-flex justify-content-center align-items-center ">
            <Select
              className=" basic-single installation_dropdown form-control form-control-sm"
              classNamePrefix="select"
              name="masterBucket"
              placeholder="Select Status Type"
              styles={style}
              value={selectDataMasterBucket}
              isSearchable={false}
              onChange={handleSelectMasterBucket}
              options={optionDataMasterBucket.map((data) => ({
                value: data.value,
                label: data.label,
              }))}
            />
            {/* <select className=" form-select select-data w-100 w-md-50  border-top-0 " 
                    name='select'
                    id='selectMasterBucket'
                    value={selectDataMasterBucket}
                    onChange={handleSelectMasterBucket}>
                        {optionDataMasterBucket.map((data,index)=>{
                            return <option className='' key={index}>{data}</option>
                        })}
                    </select> */}
          </div>
          {/* ***********All content of Master Bucket TAB************ */}
          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt="loading...."></img>
              </div>
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                {!searchInput &&
                  InstallationDataAll
                    //  .filter(install => !selectDataMasterBucket.label || install.status === selectDataMasterBucket.label)
                    .filter((install) => {
                      if (
                        selectDataMasterBucket.label &&
                        selectDataMasterBucket.label !== "Select Status Type"
                      ) {
                        return install.status === selectDataMasterBucket.label;
                      } else {
                        return true; // Show all data by default
                      }
                    })
                    .map((install, index) => (
                      <div className="col" key={index}>
                        <div className="card mb-3">
                          <div
                            className="m-3 card-data"
                            style={{ display: "inline-flex" }}
                          >
                            <div>
                              <p className="installation-card-title">
                                Status : {install.status}
                              </p>
                              <p className="installation-card-text">
                                Engineer Name : {install.engineerName}{" "}
                              </p>
                              <p className="installation-card-text">
                                CAN ID : {install.canId}{" "}
                              </p>
                              <p className="installation-card-text">
                                Order ID : {install.ID}
                              </p>
                              <p className="installation-card-text">
                                Order Type : {install.orderType}{" "}
                              </p>
                              <p className="installation-card-text">
                                Created Date : {install.createdOn}
                              </p>
                              <p
                                className="installation-card-text"
                                // style={{ lineHeight: "15px" }}
                              >
                                Customer Name : {install.customerName}
                              </p>
                              <p className="installation-card-text">
                                Area : {install.areaName}
                              </p>
                              <p className="installation-card-text">
                                Product : {install.product}
                              </p>
                              <p className="installation-card-text">
                                SLA Status : {install.slaStatus}
                              </p>
                              <p
                                className="installation-card-text"
                                // style={{ lineHeight: "15px" }}
                              >
                                SLA Clock : {install.wcrSLATime}
                              </p>
                              <p
                                className="installation-card-text"
                                // style={{ lineHeight: "15px" }}
                              >
                                Contact Person : {install.contactPerson}
                              </p>
                              <p className="installation-card-text">
                                Contact Number : {install.contactNo}
                              </p>
                              <p className="installation-card-text">
                                Appointment : {install.appointmentDate}
                              </p>
                              <p className="installation-card-text">
                                Account Turnover : {install.accountTurnOver}
                              </p>
                              <p className="installation-card-text">
                                internal Customer Category :{" "}
                                {install.customerCategory}
                              </p>
                              <div className=" text-center mt-5 mb-3">
                                {install.engineerName && (
                                  <button
                                    type="submit"
                                    disabled={true}
                                    className="btn text-light w-50 bg-dark mx-auto rounded-pill"
                                  >
                                    Assigned
                                  </button>
                                )}
                                {!install.engineerName && (
                                  <button
                                    type="submit"
                                    className="btn text-light w-50 bg-dark mx-auto rounded-pill"
                                    onClick={() => addToMyBucket(install)}
                                  >
                                    Add
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                {searchInput &&
                  InstallationDataAll.filter(
                    (install) => install.canId == searchInput
                  ) // Filter installations where canId is 123456
                    .map((install, index) => (
                      <div className="col" key={index}>
                        <div className="card mb-3">
                          <div
                            className="m-2 card-data"
                            // style={{ display: "inline-flex" }}
                          >
                            <div>
                              <p className=".installation-card-title">
                                Status: {install.status}
                              </p>
                              <p className="installation-card-text">
                                Engineer Name: {install.engineerName}{" "}
                              </p>
                              <p className="installation-card-text">
                                CAN ID: {install.canId}{" "}
                              </p>
                              <p className="installation-card-text">
                                Order ID: {install.ID}
                              </p>
                              <p className="installation-card-text">
                                Order Type: {install.orderType}{" "}
                              </p>
                              <p className="installation-card-text">
                                Created Date: {install.createdOn}
                              </p>
                              <p
                                className="installation-card-text"
                                // style={{ lineHeight: "15px" }}
                              >
                                Customer Name: {install.customerName}
                              </p>
                              <p className="installation-card-text">
                                Area: {install.areaName}
                              </p>
                              <p className="installation-card-text">
                                Product: {install.product}
                              </p>
                              <p className="installation-card-text">
                                SLA Status: {install.slaStatus}
                              </p>
                              <p className="installation-card-text">
                                SLA Clock: {install.wcrSLATime}
                              </p>
                              <p className="installation-card-text">
                                Contact Person: {install.contactPerson}
                              </p>
                              <p className="installation-card-text">
                                Contact Number: {install.contactNo}
                              </p>
                              <p className="installation-card-text">
                                Appointment: {install.appointmentDate}
                              </p>
                              <p className="installation-card-text">
                                Account Turnover: {install.accountTurnOver}
                              </p>
                              <p className="installation-card-text">
                                Internal Customer Category:{" "}
                                {install.customerCategory}
                              </p>
                              <div className=" text-center mt-5 mb-3">
                                <button
                                  type="submit"
                                  className="btn text-light w-50 bg-dark mx-auto rounded-pill "
                                  onClick={() => addToMyBucket(install)}
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          )}
        </div>

        {/* ****************** My Bucket TAB ************* */}
        <div className="tab-pane fade show active" id="myBucket">
          <div className="container-fluid mb-1 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input
                  type="text"
                  placeholder="Search"
                  className="search-box p-1 border-0"
                  style={{ width: "250px" }}
                  value={searchInputMyBucket}
                  onChange={handleSearchInputChangeMyBucket}
                />
                <i
                  className="fas fa-search text-secondary"
                  style={{ marginLeft: "-25px" }}
                  onClick={handleSearchClickMyBucket}
                ></i>
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                className=" bg-light text-center m-1"
                style={{ width: "50px", height: "27px" }}
              >
                {searchInputMyBucket.length > 0
                  ? searchCount
                  : totalCountMyBucket}
              </span>
            </div>
          </div>

          <div className="division">
            <div className="row">
              <div className="col-5">
                <div className="line l"></div>
              </div>
              <div className="col-2">
                <span>OR</span>
              </div>
              <div className="col-5">
                <div className="line r"></div>
              </div>
            </div>
          </div>

          <div className="container mb-4 d-flex justify-content-center align-items-center ">
            {/* <select className=" form-select select-data w-100 w-md-50  border-top-0 "
                    name='select'
                    id='selectMyBucket'
                    value={selectDataMyBucket}
                    onChange={handleSelectDataMyBucket}>
                        {optionDataMyBucket.map((data,index)=>{
                            return <option className="" key={index}>{data}</option>
                        })}
                    </select> */}
            <Select
              className=" basic-single installation_dropdown form-control form-control-sm p-1"
              classNamePrefix="select"
              name="myBucket"
              placeholder="Select"
              styles={style}
              value={selectDataMyBucket}
              isSearchable={false}
              onChange={handleSelectDataMyBucket}
              options={optionDataMyBucket.map((data) => ({
                value: data.value,
                label: data.label,
              }))}
            />
          </div>
          {/* ***********All content of My Bucket TAB************ */}

          <div className="container-fluid">
            <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
              {!searchInputMyBucket &&
                EngineerBucketData.filter((Bucket) => {
                  if (
                    selectDataMyBucket.label &&
                    selectDataMyBucket.label !== "Select Status Type"
                  ) {
                    return Bucket.crm_status === selectDataMyBucket.label;
                  } else {
                    return true; // Show all data by default
                  }
                }).map((Bucket, index) => (
                  <div className="col" key={index}>
                    <div className="card mb-3">
                      <div
                        className="m-2 card-data"
                        // style={{ display: "inline-flex" }}
                      >
                        <div>
                          <p className="installation-card-title">
                            Status : {Bucket.crm_status}
                          </p>
                          {/* <p className="installation-card-text">
                            Engineer Name : {Bucket.engineerName}{" "}
                          </p> */}
                          <p className="installation-card-text">
                            CAN ID : {Bucket.customerID}{" "}
                          </p>
                          <p className="installation-card-text">
                            Order ID : {Bucket.order_id}
                          </p>
                          <p className="installation-card-text">
                            Order Type : {Bucket.order_type}{" "}
                          </p>
                          <p className="installation-card-text">
                            Created Date : {Bucket.orderCreatedOn}
                          </p>
                          <p className="installation-card-text">
                            Customer Name : {Bucket.customerName}
                          </p>
                          <p className="installation-card-text">
                            Area : {Bucket.areaName}
                          </p>
                          <p className="installation-card-text">
                            Product : {Bucket.product}
                          </p>
                          <p className="installation-card-text">
                            SLA Status : {Bucket.slaStatus}
                          </p>
                          <p className="installation-card-text">
                            SLA Clock : {Bucket.wcrSlaClock}
                          </p>
                          <p className="installation-card-text">
                            Contact Person : {Bucket.contactPerson}
                          </p>
                          <p className="installation-card-text">
                            Contact Number : {Bucket.contactNo}
                          </p>
                          <p className="installation-card-text">
                            Appointment : {Bucket.appointmentDate}
                          </p>
                          <p className="installation-card-text">
                            Account Turnover : {Bucket.accountTurnOver}
                          </p>
                          <p className="installation-card-text">
                            Internal Customer Category :{" "}
                            {Bucket.customerCategory}
                          </p>
                          <p className="installation-card-text">
                            Appointment Date : {Bucket.appointmentDate}
                          </p>
                          <div>
                      <label className="select-search-label mt-1">Appointment Date :</label>
                      <StyledEngineProvider injectFirst>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDateTimePicker
                            value={selectedDates[Bucket.customerID]}
                            onChange={(newValue) => handleDateTimeChange(newValue, Bucket.customerID)}
                          />
                        </LocalizationProvider>
                      </StyledEngineProvider>
                    </div>

                          <div className="mt-4 mb-2" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                          <button
                                type="submit"
                                className="btn text-light next-btn bg-dark mx-auto rounded-pill"
                                onClick={() => redirectToProvisioning(Bucket)}
                              >
                                Next
                              </button>
                          <button
                                type="submit"
                                className="btn text-light release-btn  bg-dark mx-auto rounded-pill"
                                // onClick={() => addToMyBucket(Bucket)}
                              >
                                Release
                              </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              {searchInputMyBucket &&
                EngineerBucketData.filter(
                  (install) => install.order_id == searchInputMyBucket || install.customerID == searchInputMyBucket
                ).map((Bucket, index) => (
                  <div className="col" key={index}>
                    <div className="card mb-3">
                      <div
                        className="m-2 card-data"
                        // style={{ display: "inline-flex" }}
                      >
                        <div>
                          <p className=".installation-card-title">
                            Status : {Bucket.status}
                          </p>
                          {/* <p className="installation-card-text">
                            Engineer Name : {Bucket.engineerName}{" "}
                          </p> */}
                          <p className="installation-card-text">
                            CAN ID : {Bucket.customerID}{" "}
                          </p>
                          <p className="installation-card-text">
                            Order ID : {Bucket.order_id}
                          </p>
                          <p className="installation-card-text">
                            Order Type : {Bucket.order_type}{" "}
                          </p>
                          <p className="installation-card-text">
                            Created Date : {Bucket.orderCreatedOn}
                          </p>
                          <p className="installation-card-text">
                            Customer Name : {Bucket.customerName}
                          </p>
                          <p className="installation-card-text">
                            Area : {Bucket.areaName}
                          </p>
                          <p className="installation-card-text">
                            Product : {Bucket.product}
                          </p>
                          <p className="installation-card-text">
                            SLA Status : {Bucket.slaStatus}
                          </p>
                          <p className="installation-card-text">
                            SLA Clock : {Bucket.wcrSlaClock}
                          </p>
                          <p className="installation-card-text">
                            Contact Person : {Bucket.contactPerson}
                          </p>
                          <p className="installation-card-text">
                            Contact Number : {Bucket.contactNo}
                          </p>
                          <p className="installation-card-text">
                            Appointment : {Bucket.appointmentDate}
                          </p>
                          <p className="installation-card-text">
                            Account Turnover : {Bucket.accountTurnOver}
                          </p>
                          <p className="installation-card-text">
                            internal Customer Category :{" "}
                            {Bucket.customerCategory}
                          </p>

                          <div className="mt-4 mb-2" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                          <button
                                type="submit"
                                className="btn text-light next-btn bg-dark mx-auto rounded-pill"
                                onClick={() => redirectToProvisioning(Bucket)}
                              >
                                Next
                              </button>
                          <button
                                type="submit"
                                className="btn text-light release-btn  bg-dark mx-auto rounded-pill"
                                // onClick={() => addToMyBucket(Bucket)}
                              >
                                Release
                              </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>


        </div>
      </div>
    </>
  );
};

export default Installation;